import {createResponsiveStateReducer} from "redux-responsive"

import {
  LARGE_DESKTOP,
  DESKTOP,
  TABLET,
  PHONE
} from "@irati/ui/src/global/media"

/** @author: Richard 7/3/2018
 *  We use bootstrap a lot, their breakpoints are `@media (min-width: ...` based.
 *  Redux-responsive is max-width based so we -1 to align the 2 frameworks.
 */
export default createResponsiveStateReducer({
  // default redux-responsive breakpoints
  extraSmall: PHONE - 1,
  small: TABLET - 1,
  medium: DESKTOP - 1,
  large: LARGE_DESKTOP - 1,
  // bootstrap breakpoints aliases
  xs: PHONE - 1,
  sm: TABLET - 1,
  md: DESKTOP - 1,
  lg: LARGE_DESKTOP - 1
})
